var exports = {
  "k": "x93eb46d8--1b1520--container",
};

module.exports = exports;
